import React, { useState } from 'react';
import { apiCall } from './config';

function WhatsAppImporter({ userId, userName, onImportComplete }) {
  const [isImporting, setIsImporting] = useState(false);
  const [importStatus, setImportStatus] = useState('');

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsImporting(true);
    setImportStatus('Verarbeite Datei...');

    try {
      const text = await file.text();
      const messages = parseWhatsAppExport(text);
      
      setImportStatus(`${messages.length} Nachrichten gefunden. Importiere...`);
      
      // Sende an Backend
      const response = await apiCall(`/users/${userId}/whatsapp/import`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ messages })
      });

      if (response.ok) {
        const result = response;
        setImportStatus(`✅ ${result.imported} Nachrichten erfolgreich importiert!`);
        
        // Callback to refresh chat
        if (onImportComplete) {
          setTimeout(() => onImportComplete(), 1000);
        }
      } else {
        setImportStatus('❌ Import fehlgeschlagen');
      }
    } catch (error) {
      console.error('Import-Fehler:', error);
      setImportStatus('❌ Fehler beim Verarbeiten der Datei');
    }

    setIsImporting(false);
  };

  const parseWhatsAppExport = (content) => {
    const messages = [];
    const lines = content.split('\n');
    
    for (const line of lines) {
      // WhatsApp Format: [DD.MM.YY, HH:MM:SS] Name: Message
      const match = line.match(/\[(\d{2}\.\d{2}\.\d{2}),\s(\d{2}:\d{2}:\d{2})\]\s([^:]+):\s(.+)/);
      
      if (match) {
        const [, date, time, sender, message] = match;
        
        // Convert date format
        const [day, month, year] = date.split('.');
        const fullYear = `20${year}`;
        const timestamp = `${fullYear}-${month}-${day} ${time}`;
        
        // Determine message type
        const adminNames = ['Admin', 'Sie', 'You', 'Oktoberfest Team', 'Personal'];
        const messageType = adminNames.some(name => 
          sender.toLowerCase().includes(name.toLowerCase())
        ) ? 'outgoing' : 'incoming';
        
        messages.push({
          message,
          message_type: messageType,
          timestamp,
          status: messageType === 'outgoing' ? 'sent' : 'read'
        });
      }
    }
    
    return messages;
  };

  return (
    <div className="whatsapp-importer border rounded p-3 mb-3" style={{ backgroundColor: '#f8f9fa' }}>
      <h6 className="mb-3">
        📱 WhatsApp Chat importieren für {userName}
      </h6>
      
      <div className="mb-3">
        <small className="text-muted">
          <strong>Anleitung:</strong><br />
          1. Öffnen Sie WhatsApp auf Ihrem Handy<br />
          2. Gehen Sie zum Chat mit {userName}<br />
          3. Tippen Sie auf ⋮ → Mehr → Chat exportieren<br />
          4. Wählen Sie "Ohne Medien"<br />
          5. Laden Sie die .txt Datei hier hoch
        </small>
      </div>

      <div className="mb-3">
        <input
          type="file"
          accept=".txt"
          onChange={handleFileUpload}
          disabled={isImporting}
          className="form-control"
        />
      </div>

      {importStatus && (
        <div className={`alert ${importStatus.includes('✅') ? 'alert-success' : 
                               importStatus.includes('❌') ? 'alert-danger' : 'alert-info'}`}>
          {importStatus}
        </div>
      )}

      {isImporting && (
        <div className="text-center">
          <div className="spinner-border spinner-border-sm me-2" role="status"></div>
          Importiere...
        </div>
      )}
    </div>
  );
}

export default WhatsAppImporter;
